// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CameraOutlinedSvg from "@ant-design/icons-svg/es/asn/CameraOutlined";
import AntdIcon from '../components/AntdIcon';

var CameraOutlined = function CameraOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CameraOutlinedSvg
  }));
};

CameraOutlined.displayName = 'CameraOutlined';
export default React.forwardRef(CameraOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CameraOutlined.js
// module id = 715
// module chunks = 0